import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { Params, Router } from '@angular/router';
import { ReportsService } from 'src/app/features/consumer-report/reports.service';
import * as moment from 'moment';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';

@Component({
  selector: 'app-batch-export',
  templateUrl: './batch-export.component.html',
  styleUrls: ['./batch-export.component.scss']
})
export class BatchExportComponent
extends FeaturesBaseComponent implements OnInit, OnChanges {
  @Input() batchexport;
  @Input() disclaimerText;
  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs:any;
  rowData: any = [];
   gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  isButtonDisabled:boolean


  constructor(private router: Router, private reportsService: ReportsService,private adminViewServices:AdminViewService) {
    super();

        this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['batchexport']) {
      this.batchexport = changes['batchexport'].currentValue;
      this.rowData = this.batchexport;
    }
  }

setGrid() {
  const self = this;

    this.columnDefs = [
      { field: 'batchName', headerName: 'Batch Name', width: 210 },
      { field: 'batchId', headerName: 'Batch Number', width: 210, sort:'desc'},
      { field: 'createdDatetime', headerName: 'Created Date', width: 180, cellRenderer: (data) => {
        return moment(data.value).format('MM/DD/YYYY')}},
      { field: 'createdDatetime', headerName: 'Created Time', width: 180, cellRenderer: (data) => {
          return moment(data.value).format('hh:mm A')}},
      { field: 'createdBy', headerName: 'Created By', width: 180},
      { field: 'role', headerName: 'Role', width: 150},
      { field: 'batchDownloadUrl', headerName: 'Action', width: 180, cellRenderer: (params) => { return params.data.batchDownloadUrl && params.data.batchDownloadUrl ? `Download` : params.data.status },
      onCellClicked: function (params) { self.handleAttachment(params.data); }
      },

    ]
    //this.rowData = []
  }

  handleAttachment(data: any) {
    // action to show attachment
    if(data.batchDownloadUrl != null){

    window.open(data.batchDownloadUrl)
    }
  }
  ngOnInit(): void {
    super.ngOnInit()
    this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

  exportData() {
    this.gridApi.exportDataAsCsv();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.isLogSelected = true;
      return
    }
    this.isLogSelected = false;

  }

  createbatch(){
    let httpParams: Params = {
      startdate: '',
      enddate: ''
    }
    //let pricelisttype : 'ho'
    this.reportsService.createBatchExport().subscribe(res => {
      if (res && res) { //alert("h3");
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
          this.batchexport = res.data;
          this.router.navigate([`/features/consumer-reports/batch-export`])
          this.toastrService.success('Created batch successfully', 'Success', {
            timeOut: 3000,
          });
      }
      }
    });
    //this.router.navigate([`/features/reports/batch-export`])
    this.reloadComponent();
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }

}
